<template>
    <div class="grey lighten-3 pa-4 greyContainer">
        <div class="title">Vereinsreporting</div>
        <v-card class="mt-2" v-if="vereinsReporting">
            <v-card-text>
                <v-row no-gutters align="center">
                    <v-col cols="12" md="4" :class="[{'pr-1': $vuetify.breakpoint.mdAndUp}]">
                        <v-autocomplete v-model="vereinsReporting.selectedVerbandId"
                                        :items="vereinsReporting.landesVerbaende"
                                        label="Landesverband wählen" outlined dense item-text="text"
                                        item-value="id" clearable hide-details/>
                    </v-col>
                    <v-col cols="12" md="4" :class="[{'pl-1 pr-1': $vuetify.breakpoint.mdAndUp},{'py-3': $vuetify.breakpoint.smAndDown}]">
                        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" clearable
                                      label="Suchen" outlined single-line hide-details dense/>
                    </v-col>
                    <v-col cols="12" md="4" :class="[{'pl-1': $vuetify.breakpoint.mdAndUp}]">
                        <v-btn color="primary" block @click="exportToExcel()">
                            <v-icon>mdi-download</v-icon>Excel Export</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <vereins-liste :vereine="vereinsListe" :search="search" @filtered="setFilteredItems"/>
            <v-snackbar v-model="showSnackBar" color="success" timeout="4000">
                Es wurden {{noExported}} Vereine exportiert!
            </v-snackbar>
        </v-card>
    </div>
</template>

<script>
import VereinsListe from "@/views/vereine/vereinsListe";
import {VereinsReporting} from "@/services/data/vereine/vereinsReporting";
export default {
    name: "vereins-reporting",
    components: {VereinsListe},
    computed: {
        vereinsListe(){
            return this.vereinsReporting?.getVereinsList()
        }
    },
    data: () => ({
        search: null,
        vereinsReporting: null,
        noExported: 0,
        showSnackBar: false
    }),
    created(){
        this.init()
    },
    methods: {
        init(){
            this.vereinsReporting = new VereinsReporting()
        },
        setFilteredItems(filteredList){
            this.vereinsReporting.setFilteredItems(filteredList)
        },
        async exportToExcel(){
            this.noExported = await this.vereinsReporting.exportToExcel()
            this.showSnackBar = true
        }
    },
    watch: {
        'vereinsReporting.selectedVerbandId'(){
            this.vereinsReporting.loadVereineFromVerbandId()
        }
    }
}
</script>

<style scoped>
    .greyContainer{position: fixed; top: 48px; bottom: 0; left: 0; right: 0; overflow-y: scroll}
</style>